import { render } from "./PaintSchemeOptionsList.vue?vue&type=template&id=97b73964&scoped=true"
import script from "./PaintSchemeOptionsList.vue?vue&type=script&lang=js"
export * from "./PaintSchemeOptionsList.vue?vue&type=script&lang=js"

import "./PaintSchemeOptionsList.vue?vue&type=style&index=0&id=97b73964&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b73964"]])

export default __exports__